module.exports = __webpack_public_path__ + "static/media/img1-1.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/nutricheck_foliar/B/img1-1.png
// module id = 1451
// module chunks = 3